
<!-- API integrations screen -->
<div class="row justify-content-center m-0">

    <input id="clipboard" type="text" value="default_value" style="opacity:0.05;width:100px;height:10px;font-size:8px;border:none;" />

    <div class="col-lg-10">
        
        <!-- No API integrations added yet -->
        <div class="mt-3" style="margin-top:70px!important;" *ngIf="fourD.apis">
            <div class="mt-2 alert fdm-background-light text-center" *ngIf="fourD.apis.length == 0">
                {{ 'API.API_INTEGRATION' | translate }}
            </div>

            <div class="row">
                <div class="col-6">

                    <!-- API integrations heading -->
                    <h3>{{ 'NAV.MENU_API' | translate }}</h3>

                    <!-- API description -->
                    <div>
                        {{ 'API.API_DESC' | translate }}</div>
                    
                    <!-- API integration blocks/tables -->
                    <div *ngFor="let cur of sdks; let idx = index" class="mt-2">
                        <mat-card>
                            <div class="row">
                                <div class="col-8">
                                    <mat-form-field class="w-100">
                                        <input matInput type="text"  [(ngModel)]="cur.name"    [placeholder]="'API.NAME' | translate" />
                                    </mat-form-field>
                                </div>

                                <!-- Delete/save options -->
                                <div class="col-4" style="text-align:right;">
                                    <button mat-button color="warn" (click)="deleteApi(cur, idx)">{{ 'GENERIC.DELETE' | translate }}</button>
                                    <button mat-stroked-button color="primary" (click)="saveApi(cur)">{{ 'GENERIC.SAVE' | translate }}</button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-5">
                                    <mat-form-field class="w-100">
                                        <input #secret5 matInput type="text"  [(ngModel)]="cur.client_id"  [disabled]="true"  [placeholder]="'API.CLIENT_ID' | translate" />
                                        
                                        <!-- Copy to clipboard-->
                                        <span class="fdm-linked fdm-tiny-text" (click)="copyToClipboard(secret5)">{{ 'API.CLIP' | translate }}</span>
                                    </mat-form-field>
                                </div>

                                <div class="col-5">
                                    <mat-form-field class="w-100">
                                        <input #secret4 matInput type="password" [(ngModel)]="cur.client_secret" [disabled]="true" [placeholder]="'API.CLIENT_SECRET' | translate" />
                                        
                                        <!-- Copy to clipboard-->
                                        <span class="fdm-linked fdm-tiny-text" (click)="copyToClipboard(secret4)">{{ 'API.CLIP' | translate }}</span>
                                    </mat-form-field>
                                </div>
                            </div>
                        </mat-card>
                    </div>

                    <!-- Add new API credentials -->
                    <div class="mt-3 text-right">
                        <button mat-raised-button color="primary" (click)="addApi(availApiTypes[0])" [matTooltip]="'API.ADD_SDK' | translate">
                            <mat-icon>add</mat-icon> {{ 'API.ADD_SDK' | translate }}
                        </button>
                    </div>
                </div>

                <div class="col-6">
                    <!-- Custom processing heading -->
                    <h3>{{ 'API.CUST' | translate }}</h3>

                    <!-- Custom processing description -->
                    <div translate class="mb-2 text-default">API.OTHER_DESC
                    </div>

                    <mat-accordion>
                        <mat-expansion-panel *ngFor="let cur of otherApis; let idx = index" [expanded]="!cur.id">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="f-b primary-dark">
                                {{ 'API.' + cur.type + '.TITLE' |  translate }}
                                </mat-panel-title>
                                <mat-panel-description class="text-right">
                                {{ (cur.type == 'ProcessorAPI') ? cur.name : 'API.' + cur.type + '.DESC' |  translate }}
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <ng-container [ngSwitch]="cur.type">
        
                                <!-- Datum 360 -->
                                <ng-container *ngSwitchCase="'Datum360'">
        
                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                                <input matInput type="text" [(ngModel)]="cur.host" [placeholder]="'API.Datum360.INSTANCE' | translate"/>
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                                <input matInput type="text"  [(ngModel)]="cur.acl_host" [placeholder]="'API.Datum360.AUTH' | translate"/>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                            <input matInput type="text"  [(ngModel)]="cur.username"    [placeholder]="'API.USERNAME' | translate" />
                                        </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                            <input #secret1 matInput type="password" [(ngModel)]="cur.password" [placeholder]="'API.PASSWORD' | translate" />
                                            
                                            <!-- Copy to clipboard-->
                                            <span class="fdm-linked fdm-tiny-text" (click)="copyToClipboard(secret1)">{{ 'GENERIC.COPY_CLIPBOARD' | translate }}</span>
                                        </mat-form-field>
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                                <input matInput type="text" [(ngModel)]="cur.scope" [placeholder]="'API.SCOPE' | translate" />
                                            </mat-form-field>
                                        </div>
                                    
                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                                <input matInput type="text" [(ngModel)]="cur.activity_id" [placeholder]="'API.Datum360.QUEUE_ID' | translate" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                                <input matInput type="text" [(ngModel)]="cur.url_field" [placeholder]="'API.Datum360.URL_FIELD' | translate" />
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6">
                                            <mat-form-field class="w-100">
                                                <input matInput type="text" [(ngModel)]="cur.coords_field" [placeholder]="'API.Datum360.COORDS_FIELD' | translate" />
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div>
        
                                    </div>
                                    <div>
        
                                    </div>
                                    <div>
        
                                    </div>

                                    <!-- API test -->
                                    <button mat-stroked-button color="primary" (click)="testAPI(cur)">{{ 'API.TEST' | translate }}</button>
        
                                </ng-container>

                                <!-- AutoDesk -->
                                <ng-container *ngSwitchCase="'AutoDesk'">
                                    <div>
                                        <mat-form-field class="w-100">
                                            <input matInput type="text"  [(ngModel)]="cur.client_id"    [placeholder]="'API.CLIENT_ID' | translate " />
                                        </mat-form-field>
                                    </div>

                                    <div>
                                        <mat-form-field class="w-100">
                                            <input #secret2 matInput type="password" [(ngModel)]="cur.client_secret" [placeholder]="'API.CLIENT_SECRET' | translate" />
                                            
                                            <!-- Copy to clipboard-->
                                            <span class="fdm-linked fdm-tiny-text" (click)="copyToClipboard(secret2)">{{ 'GENERIC.COPY_CLIPBOARD' | translate }}</span>
                                        </mat-form-field>
                                    </div>
                                </ng-container>

                                <!-- Agronomeye -->
                                <ng-container *ngSwitchCase="'Agronomeye'">
                                        <div>
                                            <mat-form-field class="w-100">
                                                <input matInput type="text"  [(ngModel)]="cur.url" [placeholder]="'API.URL' | translate"/>
                                            </mat-form-field>
                                        </div>
                                        <div>
                                            <mat-form-field class="w-100">
                                                <input matInput type="text"  [(ngModel)]="cur.client_id"    [placeholder]="'API.CLIENT_ID' | translate" />
                                            </mat-form-field>
                                        </div>

                                        <div>
                                            <mat-form-field class="w-100">
                                                <input #secret3 matInput type="password" [(ngModel)]="cur.client_secret" [placeholder]="'API.CLIENT_SECRET' | translate" />
                                                
                                                <!-- Copy to clipboard-->
                                                <span class="fdm-linked fdm-tiny-text" (click)="copyToClipboard(secret3)">{{ 'GENERIC.COPY_CLIPBOARD' | translate }}</span>
                                            </mat-form-field>
                                        </div>

                                        <div qmap-question [qMap]="{id:'project', type:'object',obj_type:'Project',title:'GENERIC.PROJECT_USE' | translate }" [model]="cur">
                                        </div>
        
                                        <!-- API test -->
                                        <button mat-stroked-button color="primary" (click)="testAPI(cur)">{{ "API.SYNC_SITES" | translate }}</button>
        
                                </ng-container>

                                <!-- Switch default -->
                                <ng-container *ngSwitchDefault>
                                    <div>
                                        <!-- Name for this processor -->
                                        <mat-form-field class="w-100" *ngIf="cur.type == 'ProcessorAPI'">
                                            <input matInput type="text"  [(ngModel)]="cur.name" [placeholder]="'API.NAME' | translate"/>
                                        </mat-form-field>
                                    </div>
                                   
                                    <!-- Client ID -->
                                    <div>
                                        <mat-form-field class="w-100">
                                            <input matInput type="text"  [(ngModel)]="cur.client_id"    [placeholder]="'API.CLIENT_ID' | translate" />
                                        </mat-form-field>
                                    </div>

                                    <!-- Client Secret -->
                                    <div>
                                        <mat-form-field class="w-100">
                                            <input #secret4 matInput type="password" [(ngModel)]="cur.client_secret" [placeholder]="'API.CLIENT_SECRET' | translate" />
                                            
                                            <!-- Copy to clipboard-->
                                            <span class="fdm-linked fdm-tiny-text" (click)="copyToClipboard(secret4)">{{ 'GENERIC.COPY_CLIPBOARD' | translate }}</span>
                                        </mat-form-field>
                                    </div>      
                                </ng-container>

                                <!-- Delete / save options-->
                                <div class="align-content-right">
                                    <button mat-button color="warn" (click)="deleteApi(cur, idx)">{{ 'GENERIC.DELETE' | translate }}</button>
                                    <button mat-stroked-button color="primary" (click)="saveApi(cur)">{{ 'GENERIC.SAVE' | translate }}</button>
                                </div>

                            </ng-container>

                        </mat-expansion-panel>
                    </mat-accordion>

                    <!-- Contact us button -->
                    <div class="mt-3" *ngIf="service.showContactUs()">
                        <button mat-raised-button color="primary" (click)="navigateToRoute(routes.MAIN_CONTACT)" [matTooltip]="'MAP.GUIDES_DASHBOARD.CONTACT_US.LABEL' | translate">
                        <mat-icon>info</mat-icon> {{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.LABEL' | translate }}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<!-- Loading screen message -->
<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>
